export class NoValidActionTakenError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'NoValidActionTakenError';
  }
}
export class NodeNotFoundError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'NodeNotFoundError';
  }
}

export class NonUniqueNamespaceError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'NonUniqueNamespaceError';
  }
}

export class DuplicateRoutesError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'DuplicateRoutesError';
  }
}

export class NoFlowsRegisteredError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'NoFlowsRegisteredError';
  }
}

export class NonExistantRouteError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'NonExistantRouteError';
  }
}

export class RoutesToSelfError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'RoutesToSelfError';
  }
}
